// extracted by mini-css-extract-plugin
export default {"filterContainer":"EligibilityExclusionsDialog_filterContainer__4w+fc"};